import { request } from '@/helpers/apiClient'
import { SAS_TOKEN_CONFIG } from '@/utils/constants/apiConfig/sasTokenConfig'

export const getSasToken = async (fileName, templateType) => {
  return request(SAS_TOKEN_CONFIG.GET_SAS_TOKEN(fileName, templateType))
}
